module.exports = __webpack_public_path__ + "static/media/backoffice.614f1fe5.png";